import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ViewBookModalComponent } from '../view-book-modal/view-book-modal.component';
import data from '../../assets/data/data.json';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  bsModalRef: BsModalRef;
  constructor(private modalService: BsModalService) { }
  // @Input()
  // currentBook: string;
  
  openViewBookModal(event, index) {
    const initialState = {
      books: data.books,
      currentBook:data.books[index],
      modalTitle: data.books[index].name,
      modalPdf: data.books[index].filename,
      closeBtnName: 'Close'
    }
    this.bsModalRef = this.modalService.show(ViewBookModalComponent, { initialState });
    // return this.bsModalRef.content;
  };

  books = data.books;
  // pdfSrc: string = '/pdf-test.pdf';
  // console = console;
  ngOnInit() {

    // console.log("data ", data.books)
  }

}
